module.exports = __webpack_public_path__ + "static/media/gmail.a9a90dbd.png";